<div class="sheet-header">
  <span class="sheet-title">Filter</span>
  <button class="sheet-reset" *ngIf="activeFilterCount > 0" (click)="reset()">Zurücksetzen</button>
  <button class="sheet-close" (click)="close()"><ion-icon name="close-outline"></ion-icon></button>
</div>

<div class="sheet-body">

  <div class="sheet-section">
    <div class="sheet-label">Ansicht</div>
    <div class="toggle-row" (click)="toggleDescription()">
      <span class="toggle-label">Beschreibungstext anzeigen</span>
      <div class="toggle-switch" [class.on]="showDescription">
        <div class="toggle-thumb"></div>
      </div>
    </div>
    <div class="toggle-row" (click)="toggleComposition()">
      <span class="toggle-label">Zusammensetzung anzeigen</span>
      <div class="toggle-switch" [class.on]="showComposition">
        <div class="toggle-thumb"></div>
      </div>
    </div>
  </div>

  <div class="sheet-section" *ngIf="availableSeasons.length">
    <div class="sheet-label">Saison</div>
    <div class="sheet-chips">
      <button *ngFor="let season of availableSeasons" class="sheet-chip" [class.active]="selectedSeasons.has(season)" (click)="toggleSeason(season)">{{ season }}</button>
    </div>
  </div>

  <div class="sheet-section" *ngIf="availableSizes.length">
    <div class="sheet-label">Größe</div>
    <div class="sheet-chips">
      <button *ngFor="let sz of availableSizes" class="sheet-chip" [class.active]="selectedSizes.has(sz)" (click)="toggleSize(sz)">{{ sz }}</button>
    </div>
  </div>

  <div class="sheet-section" *ngIf="availableMaterials.length">
    <div class="sheet-label">Material</div>
    <div class="sheet-chips">
      <button *ngFor="let mat of availableMaterials" class="sheet-chip mat-chip-btn" [class.active]="selectedMaterials.has(mat.key)" (click)="toggleMaterial(mat.key)">
        <span class="chip-abbr">{{ mat.key.toUpperCase() }}</span><span class="chip-sep"> – </span><span class="chip-name">{{ mat.name.toUpperCase() }}</span>
      </button>
    </div>
  </div>

  <!-- Farbfilter: noch nicht aktiviert -->
  <!-- <div class="sheet-section" *ngIf="availableColors.length"> ... </div> -->
</div>

<div class="sheet-footer">
  <button class="apply-btn" (click)="apply()">Anwenden</button>
</div>
